import React from 'react';
import styled from 'styled-components';

import { Stack } from '../stack/stack';

type Props = {
  keys: string[];
  separator?: string;
};

const KeyBox = styled(Stack)`
  padding: 0.1em 0.4em;
  min-width: 1.6em;
  border: 1px solid #c9c9c9;
  border-radius: 4px;
  background: #f9f9f9;
  font-family: Consolas, 'Courier New', monospace;
  font-size: 0.85em;
  line-height: 1.2;
  color: #333;
`;

export const KeyBindingHint: React.FC<Props> = ({ keys, separator = '+' }) => {
  return (
    <Stack alignItems="center" aria-label={keys.join('+')} direction="row" spacing={0.35}>
      <KeyBox alignItems="center" direction="row" justifyContent="center">
        {keys.join(separator)}
      </KeyBox>
    </Stack>
  );
};
